<template>
	<v-app>
		<v-system-bar color="dark" fixed  dark height="30" class="pl-5">
			{{ $route.query.series}} / {{ $route.query.booktitle }} / {{ $route.query.unitname }}
		</v-system-bar>

		<v-row>
			<v-col cols="10">
				<div class="mt-5 pa-5">
					<LayoutSelector />
				</div>
			</v-col>

			<v-col cols="2">
				<BuilderTools @newElement="newElement"
					@saveElements="saveElementsToDb"
					@columnElement="columnElement"
					@gridSettings="gridSettings"
					:unitLayout="layout"
				/>
			</v-col>
		</v-row>

		<v-dialog v-model="modals.save.show" width="500">
			<v-card class="pa-5">
				<h4 v-if="modals.save.success" class="green--text">Congratulations!</h4>
				<h4 v-if="!modals.save.success" class="green--text">Oops! Something went wrong.</h4>
				<span>{{ modals.save.message }}</span>
				<div class="font-italic">You may click outside this window to close.</div>
			</v-card>
		</v-dialog>

		<v-dialog v-model="modals.headingGuide.show" width="400">
			<v-card class="pa-5">
				<h3 class="blue--text text-center mb-3">Guide for Teachers</h3>
				<div class="guide-box mb-5 pa-3" :contenteditable="editableContent"
					v-html="modals.headingGuide.guide"
            		@paste="filterPastedContent"
					@focusout="columnEditableData('guide', modals.headingGuide.indexes)"
				>

				</div>
				<div class="text-center">
					<v-btn color="error" class="mr-2" small dense @click="modals.headingGuide.show = false">Cancel</v-btn>
				</div>
			</v-card>
		</v-dialog>
	</v-app>
</template>

<script>
import axios from "axios"
import BuilderTools from "@/components/BuilderTools.vue"
import LayoutSelector from "@/components/LayoutSelector.vue"
import { mapGetters, mapState } from "vuex"
import { bus } from "@/main"

export default {
    components: { LayoutSelector, BuilderTools },
    data () {
        return {
            isAuthenticated: false,
            modals: {
                save: {
                    show: false,
                    success: null,
                    message: null
                },
                headingGuide: {
                    show: false,
                    guide: null,
                    indexes: null
                }
            },
            selectedColumn: {
                element: null,
                column: null
            }
        }
    },

    created () {
        if (!window.navigator.onLine) {
            this.overlay.status = 408
            this.overlay.message = "You are not connected to the internet."
        }

        else if (!this.$route.query.token) {
            this.overlay.status = 405
            this.overlay.show = false
            this.$router.push({ name: "Unauthorized" })
        }
        else {
            const decryptedToken = atob(this.$route.query.token)
            // this might need a rework
            axios.defaults.headers.common.Authorization = `Bearer ${decryptedToken}`

            this.isAuthenticated = true
        }

        bus.$on("columnForBorder", data => {
            const cols = document.querySelector(".bordered-cols.selected")
	        cols != null ? cols.classList.remove("selected") : ""
            // event.target.classList.add("selected")

            this.selectedColumn.element = data.element
            this.selectedColumn.column = data.column
        })

        bus.$on("headingGuide", indexes => {
            const { element, column, data } = indexes
            this.modals.headingGuide.guide = this.elements[element].columns[column].data[data].guide
            this.modals.headingGuide.indexes = indexes
            this.modals.headingGuide.show = true
        })
    },

    mounted () {
        // mode history is required for the route query to work
        if (this.isAuthenticated) {
            this.$store.dispatch("units/getElements", this.$route.query.unit)
                .then(() => {
                    setTimeout(() => {
                        bus.$emit("toggleModal", false, "success", "")
                    }, 1000)
                })
                .catch(err => {
                    bus.$emit("toggleModal", true, "error", err.response.data)
                })
        }
    },

    computed: {
        ...mapGetters({
            imagesForDeletion: "imagesForDeletion"
        }),
        ...mapState("units", ["layout"])
    },
    methods:
	{

	    redirectToLogin () {
	        window.open("https://ueducms.org/content-management/dist/#/")
	    },

	    async saveElementsToDb () {
	        bus.$emit("toggleModal", true, "loading", "Please wait while your data is being saved.")
	        const url = `/cms/v1/textbook/unit/${this.$route.query.unit}`
	        const data = { elements: JSON.stringify(this.elements), style: this.layout }
	        axios.patch(url, data)
	            .then(res => this.openModal(true, res.data.message))
	            .catch(err => {
	                console.log(err)
	                this.openModal(false, "Unable to save elements. Please try again.")
	            })
	        bus.$emit("toggleModal", false, "success", "")
	        this.saveElementsBtn = false
	    },

	    addGuideToHeading () {
	        this.modals.headingGuide.show = false
	    },

	    newElement (type, columns, data = null) {
	        let elementToPush
	        if (type == "close") {
	            document.querySelector(".bordered-cols.selected").classList.remove("selected")
	            this.selectedColumn.status = false

	            return
	        }
	        // using switch for these gives error. will fix when i have time

	        else if (type == "grids") {
	            elementToPush = { type: "grids" }
	            elementToPush.columns = this.createColumns("grids", columns)
	        }

	        else if (type == "banner") {
	            elementToPush = { type }
	            if (columns == "text") {
	                elementToPush.heading = "Banner heading here."
	                elementToPush.subtitle = "Banner subtitle here"
	            }
	            else if (columns == "image") {
	                elementToPush.image = data
	                elementToPush.heading = "Banner heading here."
	                elementToPush.subtitle = "Banner subtitle here."
	            }
	        }

	        type == "banner" ? this.elements.unshift(elementToPush) : this.elements.push(elementToPush)
	    },

	    columnElement (type, data = null) {
	        let elementToPush

	        if (["heading1", "heading2"].includes(type)) {
	            elementToPush = {
	                type,
	                text: "Heading here.",
	                guide: "No guides yet."
	            }
	        }

	        else if (type == "text") {
	            elementToPush = {
	                type,
	                text: "Text here."
	            }
	        }

	        else if (["imagecard", "imagecard2"].includes(type)) {
	            elementToPush = {
	                type,
	                image: null,
	                text: "Title",
	                subtitle: "subtitle here"
	            }
	        }

	        else if (type == "image") {
	            elementToPush = {
	                type,
	                image: null,
	                height: "",
	                width: ""
	            }
	        }

	        else if (type == "dialog") {
	            elementToPush = {
	                type: "dialog",
	                lines: [
	                    { name: "John Doe", dialog: "Give me a speech." }
	                ]
	            }
	        }

	        else if (type == "textcard") {
	            elementToPush = {
	                type: "textcard",
	                text: "Title",
	                subtitle: "subtitle here"
	            }
	        }

	        else if (type == "dropdown") {
	            elementToPush = {
	                type,
	                label: "Label",
	                data: "Items here",
	                image: null
	            }
	        }
	        const { element, column } = this.selectedColumn
	        this.elements[element].columns[column].data.push(elementToPush)
	    },

	    gridSettings (data) {
	        const { element, column } = this.selectedColumn
	        this.elements[element].columns[column].styles = data
	    },

	    createColumns (type, columns) {
	        const data = []
	        for (let i = 0; i < columns; i++) {
	            let item
	            if (type == "textcards") {
	                item = ["Edit Text"]
	                data.push({ data: item })
	            }
	            else if (type == "imagecards") {
	                item = [{ image: null, text: "Edit Text" }]
	                data.push({ data: item })
	            }
	            else if (type == "grids") {
	                item = []
	                const styles = {
	                    background: "",
	                    gradientBg1: "",
	                    gradientBg2: "",
	                    borderColor: "",
	                    borderWidth: "",
	                    padding: "",
	                    margin: "",
	                    textAlignment: "text-left",
	                    headingColor: "",
	                    textColor: ""
	                }
	                data.push({ data: item, styles })
	            }
	        }

	        return data
	    },

	    openModal (success, message) {
	        this.modals.save.message = message
	        this.modals.save.success = success
	        this.modals.save.show = true
	    }

	}
}
</script>

<style scoped>
.guide-box {
	border: 1px solid rgba(189, 189, 189, 0.5);
	border-radius: 5px;
}
</style>
